export var MetricsSubject;
(function (MetricsSubject) {
    MetricsSubject["GrafanaOnboarding"] = "grafana-onboarding";
    MetricsSubject["NotAnAdminNotification"] = "not-an-admin-notification";
    MetricsSubject["StartSendingMetrics"] = "start-sending-metrics";
    MetricsSubject["SuspensionBar"] = "metrics-suspension-bar";
})(MetricsSubject || (MetricsSubject = {}));
//# sourceMappingURL=metrics.enum.js.map